import { createContext, useContext, type ReactNode } from 'react';
import { loadOverview, type Overview } from './api';
import { useLive } from './hooks';
interface MarketState { data: Overview | null; loading: boolean; error: string; refresh: () => void }
const Context = createContext<MarketState | null>(null);
export function MarketProvider({ children }: { children: ReactNode }) {
  const state = useLive(loadOverview, 'overview', 30_000);
  return <Context.Provider value={state}>{children}</Context.Provider>;
}
export function useMarkets() { const value = useContext(Context); if (!value) throw Error('MarketProvider is missing'); return value; }
